import axios from 'axios'
import store from '@/vuex/store.js'

import NProgress from 'nprogress'
import { Message, Loading } from 'element-ui'

NProgress.configure({ showSpinner: false })
const request = axios.create({
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'//formdata请求
  },
})
// 加载封装
// let loading
// function startLoading () {
//   loading = Loading.service({
//     lock: true,
//     text: '加载中',
//     background: 'rgba(0, 0, 0, 0.7)'
//   })
// }

// 关闭加载
// function endLoading () {
//   loading.close()
// }
let needLoadingRequestCount = 0
export function showFullScreenLoading () {
  // if (needLoadingRequestCount === 0) {
  //   startLoading()
  // }
  needLoadingRequestCount++
}

export function tryHideFullScreenLoading () {
  // if (needLoadingRequestCount <= 0) return
  // needLoadingRequestCount--
  // if (needLoadingRequestCount === 0) {
  //   endLoading()
  // }
}

// 请求拦截器
request.interceptors.request.use(
  config => {
    config.headers['Cache-Control'] = 'no-cache' // ie清缓存，否则无法正常刷新
    config.headers['Pragma'] = 'no-cache' // HTTP/1.1版本，ie清缓存，否则无法正常刷新
    // if (config.showLoading) {
    //     showFullScreenLoading()
    // }  
    return config;
  },
  error => {
    return Promise.reject(error)
  }

)
// 响应拦截器
request.interceptors.response.use(
  response => {
    //   if (response.config.showLoading) {
    //         tryHideFullScreenLoading()
    //  }
    // 如果返回的状态码为200，说明接口请求成功，可以正常拿到数据     
    // 否则的话抛出错误
    if (response.status === 200) {
      return Promise.resolve(response);
    } else {
      return Promise.reject(response);
    }
  },
  // 服务器状态码不是2开头的的情况
  // 这里可以跟你们的后台开发人员协商好统一的错误状态码    
  // 然后根据返回的状态码进行一些操作，例如登录过期提示，错误提示等等
  // 下面列举几个常见的操作，其他需求可自行扩展
  error => {
    tryHideFullScreenLoading();
    if (error.response.status) {
      switch (error.response.status) {
        case 400:
          console.log('错误请求');
          break;
        // 401: 未登录
        // 未登录则跳转登录页面，并携带当前页面的路径
        // 在登录成功后返回当前页面，这一步需要在登录页操作。                
        case 401:
          console.log('未登录')
          break;
        // 403 token过期
        // 登录过期对用户进行提示
        // 清除本地token和清空vuex中token对象
        // 跳转登录页面 
        case 403:
          console.log('登录过期，请重新登录');
          // 清除token
          //localStorage.removeItem('token');                
          break;
        // 404请求不存在
        case 404:
          console.log('网络请求不存在');
          break;
        case 405:
          console.log('请求方法未允许');
          break;
        case 408:
          console.log('请求超时');
          break;
        case 500:
          console.log('服务器端出错');
          break;
        case 501:
          console.log('网络未实现');
          break;
        case 502:
          console.log('网络错误');
          break;
        case 503:
          console.log('服务不可用');
          break;
        case 504:
          console.log('网络超时');
          break;
        case 505:
          console.log('http版本不支持该请求');
          break;
        // 其他错误，直接抛出错误提示
        default:
          console.log(error.response.data.message);
      }
      return Promise.reject(error.response);
    }
  }
)
export default request



// WEBPACK FOOTER //
// ./src/utils/request.js